"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("@mui/material");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Button(_a) {
  var children = _a.children,
    _b = _a.isLoading,
    isLoading = _b === void 0 ? false : _b,
    disabled = _a.disabled,
    _c = _a.secondary,
    secondary = _c === void 0 ? false : _c,
    _d = _a.danger,
    danger = _d === void 0 ? false : _d,
    _e = _a.outlined,
    outlined = _e === void 0 ? false : _e,
    props = __rest(_a, ["children", "isLoading", "disabled", "secondary", "danger", "outlined"]);
  return (0, _jsxRuntime.jsxs)(_material.Button, __assign({
    disabled: isLoading || disabled,
    color: danger ? 'error' : !outlined && secondary ? 'secondary' : 'primary',
    variant: danger || outlined ? 'outlined' : 'contained'
  }, props, {
    children: [children, isLoading && (0, _jsxRuntime.jsx)(_material.CircularProgress, {
      size: 18,
      style: {
        marginLeft: '10px',
        color: 'darkgrey'
      }
    })]
  }));
}
var _default = Button;
exports.default = _default;